<template>
  <div id="simon-base">
    <div class="content">
      <component
        :is="currentView"
        :games="games"
        @changeView="changeView"
        @activateInnerView="onActivateInnerView"
        @deactivateInnerView="onDeactivateInnerView"
        @gameFinished="onGameFinished"
        @gameInit="onGameInit"
      />
      <transition name="slide-fade">
        <instructions-view
          v-if="inlineViews.instructions"
          @activateInnerView="onActivateInnerView"
          @deactivateInnerView="onDeactivateInnerView"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import WelcomeView from './views/welcome-view.vue'
import InstructionsView from './views/instructions-view.vue'
import GameStartView from './views/game-start-view.vue'

export default {
  name: 'SimonBase',
  components: {
    WelcomeView,
    InstructionsView,
    GameStartView
  },
  props: {
    games: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentView: WelcomeView,
      views: {
        welcome: WelcomeView,
        game: GameStartView
      },
      inlineViews: {
        instructions: false
      }
    }
  },
  methods: {
    changeView (view) {
      this.currentView = this.views[view]
    },
    onActivateInnerView (view) {
      this.inlineViews[view] = true
    },
    onDeactivateInnerView (view) {
      this.inlineViews[view] = false
    },
    onGameFinished (results) {
      this.$emit('finishGame', results)
    },
    callback (reponse) {
      alert(
        'Hubo un error al intentar de guardar tu juego. Por favor revisa tu conexión de internet e intenta nuevamente.'
      )
      this.currentView = WelcomeView
    },
    onGameInit () {
      this.$emit('initGame', { cb: this.callback })
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700");

#simon-base {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  .content {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all 0.3s ease-in-out;
  }
  .slide-fade-leave-active {
    transition: all 0.3s ease-in-out;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  li,
  div {
    font-family: "Source Sans Pro", sans-serif;
  }

  .btn {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 16px;
    font-weight: 700;
    border-radius: 4px;
    border: none;
    height: 40px;
    padding: 0 20px;
    margin-bottom: 20px;
    cursor: pointer;
    &.btn-primary {
      background-color: #0090ff;
      color: #fff;
      text-transform: uppercase;
    }
    &.btn-block {
      display: block;
      width: 100%;
    }
  }
  .button-wrapper {
    padding: 20px;
    max-width: 300px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/game-base.vue